import { api } from "@/lib/api";

/* Shared intake vocabulary: what a file can be, and how far it got. */
export const ACCEPT = /\.(xlsx|xlsm|xls|csv|pdf|docx|doc|txt|md|msg|eml|zip|png|jpg|jpeg|heic|webp|gif|tif|tiff|dwg|dxf)$/i;
export const ACCEPT_ATTR = ".xlsx,.xlsm,.xls,.csv,.pdf,.docx,.doc,.txt,.md,.msg,.eml,.zip,.png,.jpg,.jpeg,.heic,.webp,.gif,.tif,.tiff,.dwg,.dxf";
export const MAX_MB = 150;
export const MAX_FILES = 40;

export const FILE_STATUS = {
  venter: { label: "Venter", cls: "bg-black/[0.05] text-muted-foreground" },
  laster: { label: "Laster opp", cls: "bg-[hsl(var(--brand-soft))] text-[hsl(208_90%_34%)]" },
  tolkes: { label: "Tolkes…", cls: "bg-[hsl(var(--brand-soft))] text-[hsl(208_90%_34%)]" },
  leses: { label: "Leses med OCR…", cls: "bg-[hsl(var(--brand-soft))] text-[hsl(208_90%_34%)]" },
  tolket: { label: "Tolket", cls: "v-ok" },
  delvis: { label: "Delvis tolket", cls: "v-assumed" },
  vedlegg: { label: "Vedlegg", cls: "bg-black/[0.05] text-foreground/70" },
  duplikat: { label: "Duplikat", cls: "bg-black/[0.05] text-muted-foreground" },
  ikke_tolket: { label: "Ikke tolket – manuell", cls: "v-assumed" },
  feil: { label: "Mislykket", cls: "bg-[hsl(0_50%_46%/0.1)] text-[hsl(var(--v-blocked))]" },
};
export const DOC_STATUS_LABEL = { lest: "lest", delvis: "delvis lest", manuell: "manuell", mottatt: "mottatt", duplikat: "duplikat" };
export const ROLE_LABEL = { foresporsel: "forespørsel", spesifikasjon: "spesifikasjon", svarark: "svarark", tegning_dok: "tegning/dok", leverandortilbud: "leverandørtilbud", korrespondanse: "korrespondanse", bilde: "bilde", ukjent: "ukategorisert" };

export const fmtSize = (n) => (n == null ? "" : n < 1024 * 1024 ? `${Math.max(1, Math.round(n / 1024))} kB` : `${(n / 1024 / 1024).toFixed(n > 20 * 1024 * 1024 ? 0 : 1)} MB`);

/** Client-side gate: type and size, with a human reason. */
export function precheck(file) {
  if (!ACCEPT.test(file.name)) return "Filtypen støttes ikke (ZIP, PDF, Excel, Word, .msg/.eml, tekst, bilder, DWG/DXF)";
  if (file.size > MAX_MB * 1024 * 1024) return `Større enn ${MAX_MB} MB – del arkivet opp`;
  return null;
}

/** Upload one file with real progress. `fields` are extra form fields. */
export function uploadOne(url, file, fields, onProgress) {
  const fd = new FormData();
  fd.append("file", file);
  Object.entries(fields || {}).forEach(([k, v]) => { if (v != null) fd.append(k, v); });
  return api.post(url, fd, { headers: { "Content-Type": "multipart/form-data" }, onUploadProgress: (e) => onProgress?.(e.total ? Math.round((e.loaded / e.total) * 100) : null) });
}

/** Human summary of what a zip / file produced. */
export function docsSummary(d) {
  if (!d || !d.count) return null;
  const roles = Object.entries(d.by_role || {}).map(([r, n]) => `${n} ${ROLE_LABEL[r] || r}`).join(", ");
  const parsed = (d.parsed || []).map((p) => `${p.count} poster fra ${p.name}`).join(" · ");
  return [`${d.count} ${d.count === 1 ? "dokument" : "dokumenter"}`, roles, parsed].filter(Boolean).join(" · ");
}
